import { useEffect, useState } from "react";

import { useSession } from "next-auth/react";

const useIsAdmin = () => {
  const { data: session } = useSession();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  // Keep admin-only links out of the first client render so it matches SSG.
  return mounted ? session?.user.isAdmin ?? false : false;
};

export default useIsAdmin;
